<template>
  <div>
    <div v-if="!notVerified">
      <div class="has-text-centered membership-header">
        <h1 class="is-size-5 has-text-weight-bold">{{ $t('title.login') }}</h1>
      </div>

      <form v-on:submit.prevent="onSubmit">
        <b-field :type="{ 'is-danger': errors.has('email') }" :message="errors.first('email')">
          <b-input
            icon-pack="fas"
            icon="envelope"
            :placeholder="$t('validation.attributes.email')"
            v-model="email"
            name="email"
            v-validate="'required|email'"
          />
        </b-field>
        <b-field
          style="display:block;"
          :type="{ 'is-danger': errors.has('password') }"
          :message="errors.first('password')"
        >
          <b-input
            type="password"
            :placeholder="$t('validation.attributes.password')"
            icon-pack="fas"
            icon="key"
            password-reveal
            v-model="password"
            name="password"
            v-validate="'required'"
          />
        </b-field>
        <p class="help has-text-right is-size-7">
          <router-link class="help has-text-right is-size-7" :to="{ name: 'forgotPassword' }">{{
            $t('title.forgotPassword')
          }}</router-link>
        </p>
        <div class="field is-grouped is-grouped-centered">
          <p class="control">
            <button class="button is-vcentered is-primary login-button">
              {{ $t('button.login') }}
            </button>
          </p>
        </div>
        <div class="has-text-centered">
          <router-link :to="{ name: 'signup', query: redirectQuery }">{{
            $t('description.dontYouHaveAnAccountSignUpNow')
          }}</router-link>
        </div>
      </form>
    </div>
    <div v-else-if="notVerified">
      <div class="has-text-centered membership-header">
        <h1 class="is-size-5 has-text-weight-bold">{{ $t('description.emailIsNotVerified') }}</h1>
        <h1 class="is-size-5 has-text-weight-bold">
          {{ $t('description.verifyEmailSentAgain') }}.
        </h1>
        <h2 class="is-size-6">{{ $t('description.verifyEmailCheckSpam') }}</h2>
        <i18n path="description.verifyEmailNotReceived" tag="p" class="is-size-6">
          <template #email>
            <a :href="`mailto:${contactEmail}`">{{ contactEmail }}</a>
          </template>
        </i18n>
      </div>
    </div>
  </div>
</template>

<script>
import { LOGIN } from '../../store/actions.type'
import { redirectQuery, rememberRedirect, takeRedirect } from '../../_helpers/redirect'
import { CONTACT_EMAIL } from '../../_helpers/config'

export default {
  data () {
    return {
      email: null,
      password: null,
      notVerified: false,
      contactEmail: CONTACT_EMAIL
    }
  },
  computed: {
    redirectQuery () {
      return redirectQuery(this.$route.query)
    }
  },
  methods: {
    onSubmit () {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.$recaptchaLoaded().then(() => {
            this.$recaptcha('login').then(token => {
              this.login(this.email.toLowerCase(), this.password, token)
            })
          })
        }
      })
    },
    login (email, password, recaptchaToken) {
      this.$store
        .dispatch(LOGIN, { email, password, recaptchaToken })
        .then(res => {
          if (res.notVerified) {
            // The way back is the verification link, which carries no redirect.
            rememberRedirect(this.$route.query.redirect, email)
            this.notVerified = true
          } else {
            // A redirect a guard turns away still ends on a page; nothing to report.
            this.$router
              .push(takeRedirect(this.$route.query, email) || { name: 'home' })
              .catch(() => {})
          }
        })
    }
  }
}
</script>
